import React from 'react';
import { careersPageData } from '@data-ts/pages/careers';
import { WrapperBox, StyledCloudImage, TextWrapperBox, StyledText, StyledButton } from './CareersFooter.styles';

export const CareersFooter: React.FC = () => {
  const careersFooterData = careersPageData.careersFooter;
  return (
    <WrapperBox backgroundColor="neutra6">
      <StyledCloudImage src={'careers/footer-cta/img.jpg'} height="100%" />
      <TextWrapperBox>
        <StyledText color="neutra1" variant="hed72Hero" tagName="h2">
          {careersFooterData.title}
        </StyledText>
        <StyledButton id="ExploreOpenPositions" variant="prime" forwardedAs="a" href={careersPageData.allPostionsCta}>
          {careersFooterData.cta}
        </StyledButton>
      </TextWrapperBox>
    </WrapperBox>
  );
};
